import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { LuLogOut } from "react-icons/lu";
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { RiBox3Line } from "react-icons/ri";
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "react-pro-sidebar";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { TbArrowBearLeft2, TbTruckDelivery } from "react-icons/tb";
import { IoCloudOfflineOutline } from "react-icons/io5";
import { PiEmpty } from "react-icons/pi";

function HeadSidebar({
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const access_token = localStorage.getItem("gassol-head-branch-token");
  const [decoded, setDecoded] = useState();

  useEffect(() => {
    if (access_token) {
      setDecoded(jwtDecode(access_token));
    }
  }, []);

  const sidebarMenu = [
    {
      title: "Dashboard",
      icon: <MdOutlineSpaceDashboard />,
      link: `/head_office/dashboard`,
    },
    // {
    //   title: "My Branches",
    //   icon: <RiBox3Line />,
    //   link: `/head_office/my_branches`,
    // },
    {
      title: "Bypass Report",
      icon: <TbArrowBearLeft2 />,
      link: `/head_office/bypass_report`,
    },
    {
      title: "Offline Report",
      icon: <IoCloudOfflineOutline />,
      link: `/head_office/offline_report`,
    },
    {
      title: "Emptying Report",
      icon: <PiEmpty />,
      link: `/head_office/emptying_report`,
    },
    {
      title: "Manage Delivery Boy",
      icon: <TbTruckDelivery />,
      link: `/head_office/manage_delivery_boy`,
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("gassol-head-branch-token");
    navigate("/sign_in");
  };

  return (
    <ProSidebar
      collapsed={collapsed}
      toggled={toggled}
      onToggle={handleToggleSidebar}
      breakPoint="lg"
    >
      {/* Header */}
      <SidebarHeader
        style={{ color: "white", backgroundColor: "#F5F7F9", border: "none" }}
      >
        <Menu iconShape="circle" style={{ color: "white" }}>
          {collapsed ? (
            <MenuItem
              icon={<FaAngleDoubleRight style={{ color: "#BDBDBD" }} />}
              onClick={handleCollapsedChange}
            ></MenuItem>
          ) : (
            <MenuItem
              suffix={<FaAngleDoubleLeft style={{ color: "#BDBDBD" }} />}
              onClick={handleCollapsedChange}
            >
              <div
                style={{
                  // padding: "9px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  fontSize: 15,
                  letterSpacing: "1px",
                  color: "white",
                }}
              >
                <p className="uppercase text-center text-[#03438D] text-4xl">
                  Gassol
                </p>
              </div>
            </MenuItem>
          )}
        </Menu>
      </SidebarHeader>
      {/* Content */}
      <SidebarContent style={{ backgroundColor: "#F5F7F9", color: "#25060C" }}>
        <Menu iconShape="circle">
          {sidebarMenu.map((item, i) => (
            <MenuItem
              icon={item.icon}
              key={i}
              onClick={() => handleToggleSidebar(false)}
              className={`${
                location.pathname === item.link
                  ? "bg-[#03438D] text-white"
                  : "text-[#BDBDBD]"
              }`}
            >
              {item.title}
              <NavLink to={item.link} />
            </MenuItem>
          ))}
        </Menu>
      </SidebarContent>

      <SidebarFooter
        style={{
          textAlign: "center",
          backgroundColor: "#F5F7F9",
          border: "none",
          paddingTop: "5px",
        }}
      >
        {!collapsed && (
          <div>
            {decoded?.name && (
              <p className="text-black font-semibold text-2xl">
                {decoded?.name}
              </p>
            )}
            {decoded?.phone && <p>+91 0987654321</p>}
            {decoded?.email && <p>{decoded?.email}</p>}
          </div>
        )}
        <div
          onClick={handleLogout}
          className="sidebar-btn-wrapper font-semibold text-lg p-4"
          style={{
            // borderTop: "2px solid #3b2025",
            // padding: "16px",
            color: "#25060C",
          }}
        >
          <div
            className="sidebar-btn bg-[#BDBDBD] font-normal tracking-[1px]"
            style={{ cursor: "pointer", color: "#fff" }}
          >
            <LuLogOut className="profile-icon" />
            <p className="ml-3">Logout</p>
          </div>
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
}

export default HeadSidebar;
